import { authorizationGet, isSetToken, logOut } from "@/api/users.api";
import { validatePrivilege } from "@/router/utils";
import { AUTH_NAME, AUTH, HOME } from "./type";

const ifAuthenticated = (to, from, next) => {
  let auth = authorizationGet();
  if (isSetToken(auth)) {
    if (validatePrivilege(auth)) {
      let priv = auth.privilege.split(",");
      if (
        to.matched.some(record =>
          record.meta.roles.some(r => priv.some(p => p === r))
        )
      ) {
        next();
      } else {
        next(HOME);
      }
    } else {
      logOut();
      next(AUTH);
    }
  } else {
    next({
      name: AUTH_NAME,
      query: { redirect: to.fullPath }
    });
  }
};

export { ifAuthenticated };
